module.exports = false;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_library.js
 ** module id = 56
 ** module chunks = 0
 **/